export {
    reload,
    replace,
    pathname,
    location,
    href,
    hash,
    origin,
    search,
    open,
    assign,
    isValidLocationOld,
    isValidLocationNew,
} from './location';
